import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import api from "../../../../../../api/api";
import { compeletd_btn } from "../../../../../../assets/images/images";
import { openbook2 } from "../../../../../../assets/images/images";
import { useAuth } from "../../../../../../features/auth/AuthContext";

import { format } from "date-fns";
import { marked } from "marked";
import { toast } from "react-toastify";
import { Course_created_successfully_image, book_animate } from "../../../../../../assets/images/images";
import StudentLessonChatbot from "../../../../../../components/studentLessonChatbot/StudentLessonChatbot";
import { getTitle } from "../../../../../../utils/utlis";
import BackButton from "../../../../../../components/BackButton/BackButton";
import PreprocessAndRenderLatex from "../../../../../../components/ProcessRenderLatex";
import { addIdsToParagraphs, generateIdFromHeader } from "../../../../../../utils/utlis";
import AiVoiceanimation from "../../../../../../components/AiVoiceanimation/AiVoiceanimation";
import { useDispatch, useSelector } from "react-redux";
import { parseKaTeX } from "../../../../../../utils/validator";
import "./OverviewLesson.css";
import { Tooltip } from "react-tooltip";
import { Ring } from "@uiball/loaders";
import { Fab } from "@mui/material";
import CustomTooltip from "../../../../../customtooltip/CustomTooltip";
import MultipleAssignmentviewPopup from "../../../../../../components/MultiplePractiseAssignments/MultipleAssignmentviewPopup";
import { createAssignmentStatus } from "../../../../../../state/actions/createAssignmentStatusAction";
import { processLatex } from "../../../../../../utils/PreProcessorLatexCode";
import Loader from "../../../../../../components/FileRepo/Components/Loader";
import LoadingComponent from "../../../../../../components/LoadingComponent/LoadingComponent";
import {
  getYoutubeVideoId,
  playYoutubeAt,
  withYoutubeJsApi,
  ytSecondsFromUrl,
} from "./youtubePlayer";

const LESSSONSTATUS = {
  NOT_STARTED: 1,
  STARTED: 2,
  COMPLETED: 3,
};


// One lesson video: black shimmer skeleton until the YouTube player fires onLoad,
// then the iframe fades in. Without `video` it renders the skeleton alone.
const LessonVideo = ({ video }) => {
  // keyed by src so a src change on the same instance shows the skeleton again
  const [loadedSrc, setLoadedSrc] = useState(null);
  const loaded = !!video && loadedSrc === video.src;

  return (
    <div className="lesson-video-row">
      <div className={`lesson-video-frame${loaded ? "" : " is-loading"}`} aria-busy={!loaded}>
        {video && (
          <iframe
            data-yt-player="true"
            data-yt-id={video.videoId}
            className={loaded ? "is-loaded" : ""}
            src={video.src}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            onLoad={() => setLoadedSrc(video.src)}
          />
        )}
      </div>
    </div>
  );
};

const OverviewLesson = ({ setlessonParent, setCanDownloadParent, setLessonFilesParent, setrubricDetails, setLessonPart, setIsPlayingTwo, setParentActiveTab }) => {
  const { course_id, lesson_id } = useParams();
  const { token } = useAuth();
  const [showreuestsuccesfully, setshowreuestsuccesfully] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const course = location?.state?.course || {};
  const [lesson, setLesson] = useState(location?.state?.lesson || {});
  const [lessonJson, setLessonJson] = useState([]);

  // True until getLessonById resolves — prevents "undefined" flashing in
  // PreprocessAndRenderLatex before lesson.description arrives from the API.
  // Initialised to false only when location.state already carries a description
  // (navigation from a page that pre-populated the state), so there's no
  // unnecessary loader flash for users who already have the content.
  const [lessonContentLoading, setLessonContentLoading] = useState(
    !location?.state?.lesson?.description
  );

  const [assignments, setAssignments] = useState([]);
  const [startAssigment, setStartAssigment] = useState(true);
  const [startLessonDtls, setstartLessonDtls] = useState(false);
  const [assignStatus, setassignStatus] = useState(null);

  const [canDownload, setCanDownload] = useState(false);
  const [lessonFiles, setLessonFiles] = useState([]);
  const [assignmentPopUp, setAssignmentPopUp] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [selectedAssignmentIndex, setSelectedAssignmentIndex] = useState(null);
  const [assignmentRubric, setAssignmentRubric] = useState(null);
  const globalState = useSelector((state) => state.globalState);
  const [isPracticeAssignment, setIsPracticeAssignment] = useState(false);
  const [practiceAssignments, setPracticeAssignments] = useState([]);
  const assignmentCount = lesson?.assignment_count
  const courseType = location?.state?.course?.course_type
  const [isButtonDisable, setisButtonDisable] = useState(false)

  const lessonBodyRef = useRef(null);


  const [startAssiLessonStart, setstartAssiLessonStart] = useState(
    location?.state?.lesson?.lesson_status === "Completed" ? true : false
  );
  const [rubrics, setRubrics] = useState({});

  // `lesson` first comes from location.state (navigation copy, may be stale) and is
  // then replaced by getLessonById. Mount videos only once the fresh copy is in, so a
  // stale copy can't flash extra / different players (each mount = black box + reload).
  const [lessonFetched, setLessonFetched] = useState(false);

  // ── YouTube videos pulled OUT of the lesson HTML ─────────────────────────
  // Extract EVERY YouTube iframe and strip them from the lesson HTML, then run
  // the existing paragraph-id logic on the cleaned HTML.
  const { modifiedDescription, youtubeVideos } = useMemo(() => {
    const raw = lesson?.description || "";
    if (!raw) return { modifiedDescription: "", youtubeVideos: [] };

    const videos = [];
    let cleanHtml = raw;
    try {
      const doc = new DOMParser().parseFromString(raw, "text/html");
      doc.querySelectorAll('iframe[src*="youtube.com/embed/"], iframe[src*="youtube-nocookie.com/embed/"]')
        .forEach((iframe) => {
          const src = iframe.getAttribute("src") || "";
          if (src) {
            videos.push({
              src: withYoutubeJsApi(src), // enablejsapi=1 so postMessage seek/pause works
              videoId: getYoutubeVideoId(src),
              title: iframe.getAttribute("title") || "YouTube video player",
            });
          }
          iframe.remove(); // remove so it doesn't render inline / twice
        });
      cleanHtml = doc.body.innerHTML;
    } catch (e) {
      console.error("Failed to extract lesson videos:", e);
      cleanHtml = raw;
    }

    return {
      modifiedDescription: addIdsToParagraphs(cleanHtml, lessonJson),
      youtubeVideos: videos,
    };
  }, [lesson?.description, lessonJson]);

  // Delegate timestamp clicks from the rendered lesson body: play the video whose
  // id matches the button's data-url, pause the others, and scroll to it.
  useEffect(() => {
    const container = lessonBodyRef.current;
    if (!container) return;

    const onClick = (e) => {
      const btn = e.target.closest(".youtube_timestamp");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const url = btn.getAttribute("data-url") || "";
      const seconds = ytSecondsFromUrl(url, btn.textContent);
      const iframe = playYoutubeAt(container, url, seconds);

      // video isn't embedded in this lesson → open the link instead
      if (!iframe) {
        if (url) window.open(url, "_blank", "noopener,noreferrer");
        return;
      }
      iframe.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    container.addEventListener("click", onClick);
    return () => container.removeEventListener("click", onClick);
  }, [modifiedDescription, lessonJson, lessonContentLoading]);

  useEffect(() => {
    if (assignments.length > 0 || practiceAssignments.length > 0) {

      const findIncompletePracticeAssignment = (assignment_id) => {
        if (!practiceAssignments || practiceAssignments.length === 0) return null;

        return practiceAssignments.find(
          (pa) =>
            pa.assignment_id === assignment_id && pa.assignment_completed_at === null && pa.assignment_json && pa.assignment_json.length > 0
        );
      };



      for (let i = 0; i < assignments.length; i++) {
        const a = assignments[i];

        if (a.assignment_completed_at === null) {
          setisButtonDisable(true);
          break;
        } else {
          const incompletePractice = findIncompletePracticeAssignment(a.assignment_id);
          if (incompletePractice) {
            setisButtonDisable(true)
            break;
          }
        }

        const incompletePractice = practiceAssignments.find(
          (pa) =>
            pa.assignment_id === a.assignment_id &&
            pa.assignment_completed_at === null &&
            (!pa.assignment_json || pa.assignment_json.length === 0)
        );
        if (incompletePractice) {
          toast.info("Practice assignment is being generating. Please wait...");
          return;
        }
      }
    }


  }, [assignments, practiceAssignments])

  useEffect(() => {
    if (course_id) {
      getLessonById(course_id, lesson_id);
    }
    if (lesson_id) {
      const formattedDate = format(Date.now(), "yyyy-MM-dd HH:mm:ss.SSSXXX");

      setLessonStartedDate(formattedDate);
      setLessonCompletedDate(null);
    }
    return () => { };
  }, [course_id, lesson_id]);

  useEffect(() => {
    const interval = setInterval(() => {
      getAssignment(lesson_id);
    }, 120000);
    return () => clearInterval(interval);
  }, [lesson_id]);
  // track the left side of lesson topics
  // Add IntersectionObserver to track which section is in view while scrolling
  useEffect(() => {
    if (!lessonJson || lessonJson.length === 0) return;

    const observerOptions = {
      root: scrollableDivRef.current,
      rootMargin: '-20% 0px -70% 0px', // Trigger when section is 20% from top
      threshold: 0,
    };

    const observerCallback = (entries) => {
      if (isScrollingToSectionRef.current) return;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Get the section header from the element's id
          const sectionId = entry.target.id;

          // Find the matching index in lessonJson
          const matchingIndex = lessonJson.findIndex(
            (item) => generateIdFromHeader(item.section_header) === sectionId,
          );

          if (matchingIndex !== -1) {
            setActiveIndex(matchingIndex);
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all section elements
    lessonJson.forEach((item) => {
      const id = generateIdFromHeader(item.section_header);
      const element = id ? document.getElementById(id) : null;

      if (element) {
        observer.observe(element);
      }
    });

    // Cleanup
    return () => {
      lessonJson.forEach((item) => {
        const id = generateIdFromHeader(item.section_header);
        const element = id ? document.getElementById(id) : null;

        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, [lessonJson]);

  const [lessonStatus, setLessonStatus] = useState(null);
  const getLessonById = async (course_id, lesson_id) => {
    setLessonFetched(false);
    try {
      const response = await api.get(`lessons/get-lesson/${lesson_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200) {
        const lessonData = response?.data?.data;
        // Modify the name property here
        const appendText = `<h3 class=\"editor-heading-h3\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\"><strong class=\"editor-text-bold\" style=\"white-space: pre-wrap;\">Note to Students:-</strong> <br>There are a total of 5 ${response?.data?.data?.competitive_exam === 'SAT' ? 'SAT' : 'ACT'}s in this series. Please complete the current ${response?.data?.data?.competitive_exam === 'SAT' ? 'SAT' : 'ACT'} to unlock the next one, which will automatically appear on your dashboard. <br>You can access the completed ${response?.data?.data?.competitive_exam === 'SAT' ? 'SAT' : 'ACT'}s anytime from the Completed Courses section. </h3> <br><br>`
        // const appendText = "<h3 class=\"editor-heading-h3\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\"><strong class=\"editor-text-bold\" style=\"white-space: pre-wrap;\">Note to Students:-</strong> <br>There are a total of 5 SATs in this series. Please complete the current SAT to unlock the next one, which will automatically appear on your dashboard. <br>You can access the completed SATs anytime from the Completed Courses section. </h3> <br><br>"

        const updatedLesson = {
          ...lessonData,
          description: ` ${appendText} ${lessonData.description}`,
        };
        // setLesson(response?.data?.data);
        if (response?.data?.data?.course_type === 2) {
          setLesson(updatedLesson);
          setLessonPart(updatedLesson);
        } else {
          setLesson(lessonData);
          setLessonPart(lessonData);
        }
        setlessonParent(response?.data?.data)
        setLessonStatus(response?.data?.data?.lesson_status);
        setLessonJson(response?.data?.data?.lesson_json || []); // Update this line
        setCanDownload(response?.data?.data?.is_file_download);  // Store the is_file_download flag
        setCanDownloadParent(response?.data?.data?.is_file_download);
        setLessonFiles(response?.data?.data?.lessons_file_list || []); // Save the list of files
        setLessonFilesParent(response?.data?.data?.lessons_file_list || [])
        if (response?.data?.data?.lesson_status !== "Completed") {
          handleComplete(totalEstimatedTime, lesson?.lesson_id, 2);
        }

        getRubric(lesson_id);
        getAssignment(lesson_id);
      }
    } catch (error) {
      // Swallow silently to match original behaviour
    } finally {
      // Always clear the loader — even on error — so the user is never
      // stuck looking at a spinner with no way to recover.
      setLessonContentLoading(false);
      // Videos render only after this — even on error (falls back to the navigation copy)
      setLessonFetched(true);
    }
  };
  const getRubric = async (lesson_id) => {

    const endpoint =
      courseType === 2
        ? `competitive/assignments/get-rubric-by-lesson-id/${lesson_id}/`
        : `assignments/get-rubric-by-lesson-id/${lesson_id}/`;

    await api
      .get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const _rubricHeader =
            response?.data?.data?.length > 0
              ? marked(response?.data?.data[0]?.rubric).substring(0, 20)
              : "";

          const rubric = {
            section_time: "0",
            section_header: "Rubric",
          };
          if (lessonJson?.length > 0) {
            setLessonJson((pre) => [...pre, rubric]);
          }
          setRubrics(response?.data?.data);
          setrubricDetails(response?.data?.data)
        } else {
        }
      })
      .catch((error) => { });
  };
  const getAssignment = async (lesson_id) => {
    const endpoint =
      courseType === 2
        ? `/competitive/assignments/get-assignments-by-lesson/${lesson_id}/`
        : `/assignments/get-assignments-by-lesson/${lesson_id}/`;

    await api
      .get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })//response.pending then loader
      .then(async (response) => {
        if (response.status === 200) {
          setAssignments(response?.data?.data);
          setassignStatus(response?.data?.data[0]?.assignment_status?.status);
          if (
            response?.data?.data?.length > 0 &&
            response?.data?.data[0]?.assignment_status?.status !== "Completed"
          ) {
            startLessonDtls(true);
            setStartAssigment(true);

          }


          // Fetch practice assignments for all normal assignments
          const allPracticeAssignments = [];
          for (const assignment of response?.data?.data) {
            try {
              const endpoint =
                courseType === 2
                  ? `/competitive/assignments/get-practice-assignments-by-assignment/${assignment.assignment_id}/`
                  : `/assignments/get-practice-assignments-by-assignment/${assignment.assignment_id}/`;

              const practiceResponse = await api.get(
                endpoint,
                {
                  headers: {
                    Authorization: `Token ${token}`,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
              if (practiceResponse.status === 200) {
                allPracticeAssignments.push(...practiceResponse.data.data);
              }
            } catch (err) {
              // Ignore error or handle as needed
            }
          }

          setPracticeAssignments(allPracticeAssignments);


        } else {
        }
      })
      .catch((error) => { });
  };


  const [activeIndex, setActiveIndex] = useState(0);



  const handleScrollToSection = (sectionHeader, index) => {
    setActiveIndex(index);
    isScrollingToSectionRef.current = true;
    const id = generateIdFromHeader(sectionHeader);
    const element = id ? document.getElementById(id) : null;

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      // Ignore IntersectionObserver updates until smooth scroll finishes
      const scrollDurationMs = 600;
      setTimeout(() => {
        isScrollingToSectionRef.current = false;
      }, scrollDurationMs);
    } else {
      isScrollingToSectionRef.current = false;
    }
  };
  const goBack = () => {
    navigate("/dashboard/home", {
      state: {
        my_course_sel_course: course,
        student_dashboard_tab_key: "My Courses",
      },
      replace: true,
    });
  };
  function estimateReadTime(text, wordsPerMinute) {
    const wordCount = text.split(/\s/).length;
    const time = Math.ceil(wordCount / wordsPerMinute);
    return time;
  }

  function structureText(htmlString) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlString, "text/html");
    let lessons = [];
    const wordsPerMinute = 250; // Average reading speed
    let headings = doc.querySelectorAll("h2");
    headings.forEach((heading) => {
      let lesson = {
        title: heading.textContent,
        time: estimateReadTime(heading.textContent, wordsPerMinute),
        subtitle: [],
      };
      let sibling = heading.nextElementSibling;
      while (sibling && sibling.tagName.toLowerCase() !== "h2") {
        lesson.subtitle.push({
          text: sibling.textContent,
          time: estimateReadTime(sibling.textContent, wordsPerMinute),
        });
        sibling = sibling.nextElementSibling;
      }
      lessons.push(lesson);
    });
    return lessons;
  }
  const htmlString = lesson?.description || "";
  let result = structureText(htmlString);
  const [totalEstimatedTime, setTotalEstimatedTime] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const scrollableDivRef = useRef(null);
  const isScrollingToSectionRef = useRef(false);
  const [currentEstimatedTime, setCurrentEstimatedTime] = useState(0);
  const [lessonStartedDate, setLessonStartedDate] = useState(null);
  const [lessonCompletedDate, setLessonCompletedDate] = useState(null);
  const [isEnrolled, setIsEnrolled] = useState(false);
  useEffect(() => {
    if (lesson?.description) {
      let lessons = structureText(lesson?.description ?? "");
      // Calculate total estimated time
      let totalTime = 0;
      lessons?.forEach((l) => {
        totalTime += l?.time;
        l?.subtitle?.forEach((s) => (totalTime += s?.time));
      });
      setTotalEstimatedTime(totalTime);
    }
  }, [lesson?.description]);
  useEffect(() => {
    handleComplete(totalEstimatedTime,
      lesson?.lesson_id,
      3);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Ensure the ref is pointing to a valid DOM element
      if (!scrollableDivRef?.current) {
        return;
      }
      const currentScrollTop = scrollableDivRef?.current?.scrollTop;
      const maxScrollTop =
        scrollableDivRef?.current?.scrollHeight -
        scrollableDivRef?.current?.clientHeight;

      if (startTime === null) {
        setStartTime(Date.now());
      }

      if (currentScrollTop >= maxScrollTop) {
        const endTime = Date.now();
        const timeTaken = Math.ceil((endTime - startTime) / 60000); // convert ms to min
        setCurrentEstimatedTime(timeTaken);
      }
    };
    if (scrollableDivRef.current) {
      scrollableDivRef?.current?.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollableDivRef.current) {
        scrollableDivRef?.current?.removeEventListener("scroll", handleScroll);
      }
    };
  }, [startTime]);

  // When the user marks as complete
  const handleComplete = (time, lessonid, status) => {
    toast.dismiss();
    if (status === 2 && !lessonStartedDate) {
      if (status === 3) {
        toast.error("Please read the lesson first", {
          position: "top-center",
        });
      }
      return;
    }

    if (lesson) {
      const endTime = Date.now();
      const timeTaken = Math.ceil((endTime - startTime) / 60000); // convert ms to min
      setCurrentEstimatedTime(timeTaken);

      const formattedDate = new Date().toISOString().replace(/\.\d{3}/, "");
      // post mark as complted
      const formData = new FormData();
      formData.append("status", status);
      formData.append("lesson_id", lessonid);
      if (status === 3) {
        formData.append("completed_at", formattedDate);
        setLessonStartedDate(null);
        setLessonCompletedDate(formattedDate);
      }
      const url = "lessons/update-lesson-status/";
      const headers = {
        Authorization: `Token ${token}`,
      };
      api
        .post(url, formData, { headers })
        .then((response) => {
          if (response.data.status === 200) {
            setLessonStatus("Completed");
            if (status === 3) {
            }
            setTimeout(() => {
              if (status === 3) {
                setIsEnrolled(true);
              }

            }, 1000);
            setStartAssigment(true);
            setstartAssiLessonStart(true);
          }
        })
        .catch((error) => {
        });
    }
  };
  const onStartAssignment = (status = 3) => {

    const course_id = course?.course_id;
    const lesson_id = lesson?.lesson_id;
    const assignment_id =
      assignments?.length > 0 ? assignments[0]?.assignment_id : null;
    if (!assignment_id || status !== 2) {
      if (status !== 2) {
        toast.error("No assignment found", {
          position: "top-center",
        });
      }
      return;
    }
    try {
      const state = {
        course: JSON.parse(JSON.stringify(course)),
        lesson: JSON.parse(JSON.stringify(lesson)),
        assignment:
          assignments?.length > 0
            ? JSON.parse(JSON.stringify(assignments[0]))
            : null,
        rubric:
          rubrics?.length > 0 ? JSON.parse(JSON.stringify(rubrics[0])) : null,
      };
      navigate(
        `/course/${course_id}/lesson/${lesson_id}/assignment/${assignment_id}/preview`,
        { state }
      );
    } catch (error) {
      console.error("Serialization error:", error);
    }
  };

  const [activeTab, setActiveTab] = useState("lessons"); // Default active tab is 'lessons'
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const [openDialog, setOpenDialog] = useState(false);

  const handleCancelClick = () => {
    setOpenDialog(true);
  };
  const cancelRegistration = () => {
    setOpenDialog(false);
    document.body.style.overflow = "auto";
    // Reset the selected role or handle cancellation
  };

  // State to track whether it's playing.
  const [isPlaying, setIsPlaying] = useState(false);

  // Toggle the play state.
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };



  const downloadAsPdf = async () => {

    try {
      const response = await api.post(`auth/convert-html-to-pdf/`, { html_text: parseKaTeX(lesson.description) }, {
        responseType: 'blob',  // Important for handling binary data
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${lesson?.name}.pdf`); // or any other extension
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        toast.success("Download successful!");
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error("Download failed.");
    }
  };

  const downloadFile = (fileUrl, fileName) => {
    if (!canDownload) {
      toast.error("Downloading is disabled for this lesson.");
      return;
    }
    downloadAsPdf();
  };

  const initiateDownload = (file) => {
    fetch(file.file_url)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = file.original_name;
        document.body.appendChild(link);
        link.dispatchEvent(new MouseEvent('click'));
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      })
      .catch(error => console.error('Download failed:', error));
  };

  const downloadAllFiles = () => {
    if (!canDownload) {
      toast.error("Downloading is disabled for this lesson.");
      return;
    }

    if (lessonFiles.length === 0) {
      toast.error("No files to download.");
      return;
    }

    // toast.info(`Starting download of ${lessonFiles.length} files...`);
    toast.success("Download successful!");

    lessonFiles.forEach((file, index) => {
      // Stagger downloads with a minimal delay between each
      setTimeout(() => {
        initiateDownload(file);
      }, index * 100);  // Small delay between each download (100 ms)
    });
  };

  const startAssignmentPopupHandler = () => {
    if (!assignments || assignments.length === 0) {
      toast.info("No assignments available.");
      return;
    }

    // Helper to find first incomplete practice assignment for given assignment_id
    const findIncompletePracticeAssignment = (assignment_id) => {
      if (!practiceAssignments || practiceAssignments.length === 0) return null;

      return practiceAssignments.find(
        (pa) =>
          pa.assignment_id === assignment_id && pa.assignment_completed_at === null && pa.assignment_json && pa.assignment_json.length > 0
      );
    };

    let foundAssignment = null;
    let foundIndex = null;
    let foundIsPractice = false;

    for (let i = 0; i < assignments.length; i++) {
      const a = assignments[i];

      if (a.assignment_completed_at === null) {
        foundAssignment = a;
        foundIndex = i;
        foundIsPractice = false;
        break;
      } else {
        const incompletePractice = findIncompletePracticeAssignment(a.assignment_id);
        if (incompletePractice) {
          foundAssignment = incompletePractice;
          foundIndex = i; // Parent assignment index (optional)
          foundIsPractice = true;
          break;
        }
      }

      const incompletePractice = practiceAssignments.find(
        (pa) =>
          pa.assignment_id === a.assignment_id &&
          pa.assignment_completed_at === null &&
          (!pa.assignment_json || pa.assignment_json.length === 0)
      );
      if (incompletePractice) {
        toast.info("Practice assignment is being generating. Please wait...");
        return;
      }
    }

    if (!foundAssignment) {
      toast.info("No assignments available.");
      return;
    }

    let rubricId = null;
    if (foundAssignment.rubric_id !== null) {
      for (let i = 0; i < rubrics.length; i++) {
        if (foundAssignment.rubric_id === rubrics[i].rubric_id) {
          rubricId = rubrics[i];
          break;
        }
      }
    }

    setSelectedAssignment(foundAssignment);
    setSelectedAssignmentIndex(foundIndex);
    setAssignmentRubric(rubricId);
    setAssignmentPopUp(!assignmentPopUp);
    setIsPracticeAssignment(foundIsPractice);

  };


  const enterFullscreen = () => {
    const elem = document.documentElement; // full page

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  };


  const startAssignmentHandler = (status = 3) => {
    enterFullscreen();
    const course_id = course?.course_id;
    const lesson_id = lesson?.lesson_id;
    const id = selectedAssignment?.assignment_id;

    const assignmentIdToSend = selectedAssignment?.id || selectedAssignment?.assignment_id;


    const payload = {
      student_id: globalState?.student_details?.data?.student_id,
      assignment_id: assignmentIdToSend,
      status: 3,
      completed_name: selectedAssignment?.name,
      assignment_type: isPracticeAssignment ? 2 : 1,
    };

    dispatch(createAssignmentStatus(payload, token, courseType));

    try {
      const state = {
        course: JSON.parse(JSON.stringify(course)),
        lesson: JSON.parse(JSON.stringify(lesson)),
        assignment: selectedAssignment,
        rubric: assignmentRubric ? JSON.parse(JSON.stringify(assignmentRubric)) : null,
        assignmentDtls: assignments?.length > 0 ? JSON.parse(JSON.stringify(assignments)) : null,
        type: isPracticeAssignment ? 2 : 1,
      };

      navigate(`/course/${course_id}/lesson/${lesson_id}/assignment/${assignmentIdToSend}/preview`, { state });
    } catch (error) {
      console.error("Serialization error:", error);
    }
  };



  const handleProceedToAssignmentClick = () => {
    setParentActiveTab("Assignments");
  }




  return (
    <>
      <div className="" id="OverviewLesson-section">
        <div className="Overview-Lesson-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-lessons-wrapper">
                  <div className="tab-content mt-0">
                    {activeTab === "lessons" && (
                      <div className="inner-lesson-and-inner-Assignment-main-container">
                        <div className="Overview-Lesson-inner-header">
                          <div className="view-course-Details-back-btn-folder">
                          </div>
                        </div>
                        <div className="overview-lesson-read-wrapper">
                          <div className="overview-lesson-read-left-section">
                            <div className="overview-lesson-read-left-container">
                              {location?.state?.lesson.is_skip ?
                                (<>
                                  <div className="" style={{ textAlign: 'center', color: '#666' }}>
                                    <span className="Students-courses-details-folder span">No headers to preview</span>
                                  </div>
                                </>) :
                                (<>
                                  {lessonJson?.map((item, index) => (
                                    <div
                                      key={index}
                                      className={`overview-lesson-read-left-box-folder cursor-pointer ${index === activeIndex ? "active" : ""
                                        }`}
                                      onClick={() =>
                                        handleScrollToSection(
                                          item.section_header,
                                          index
                                        )
                                      }
                                    >
                                      <div className="overview-lesson-read-left-des">
                                        <p>
                                          <span><PreprocessAndRenderLatex
                                            content={marked(item.section_header).replace(/(?<!\$)\$(?!\$)(.*?)\$+(?!\$)/g, (match, p1) => `$$${p1}$$`)}
                                            isBlockMath={false}
                                          /></span>
                                        </p>
                                      </div>
                                    </div>
                                  ))}
                                </>)
                              }

                            </div>
                          </div>
                          <div className="overview-lesson-read-right-section">
                            <div className="overview-lesson-read-right-body">
                              <div className="overview-lesson-read-right-inner-body">
                                {location?.state?.lesson.is_skip ?
                                  (<div className="no-lesson-created-to-proceed-assignment">
                                    <img style={{ width: "252px" }} src={book_animate} alt="book_animate" />
                                    <h3>You're all caught up here!</h3>
                                    {/* fixed */}

                                    <span className="Students-courses-details-folder span">Let's move forward to your assignment</span>

                                    <button onClick={handleProceedToAssignmentClick} className="Student-Active-start-Lesson">Proceed to assignment</button>
                                  </div>) : (
                                    lessonContentLoading ? (
                                      <div className="spinner-folder">
                                        <LoadingComponent loading_text="Educating the Future, Loading Now." />
                                      </div>
                                    ) : (
                                      <div ref={lessonBodyRef}>
                                        {lessonFetched
                                          ? youtubeVideos.map((video, i) => (
                                            <LessonVideo key={`yt-${i}`} video={video} />
                                          ))
                                          : youtubeVideos.length > 0 && (
                                            // fetch in flight: one placeholder (navigation copy's count may be stale).
                                            // Same key as the first real video → the box stays put, no remount.
                                            <LessonVideo key="yt-0" video={null} />
                                          )}
                                        <PreprocessAndRenderLatex
                                          ref={scrollableDivRef}
                                          content={lesson?.description === "@$%^231#^#a5fgd%532^&4R3&" ? "" : modifiedDescription}
                                          isBlockMath={false}
                                        />
                                      </div>
                                    )
                                  )
                                }
                                {/* <PreprocessAndRenderLatex
                                  ref={scrollableDivRef}
                                  content={
                                    modifiedDescription
                                  }
                                /> */}
                                <div className="lesson-Completed-btn-wrapper">
                                  <div className="overview-lesson-mark-complete-btn">
                                    <button
                                      className="lesson-overview-Completed-btn"
                                      onClick={() =>
                                        handleComplete(
                                          totalEstimatedTime,
                                          lesson?.lesson_id,
                                          3
                                        )
                                      }
                                      type="button"
                                    >
                                      <img
                                        className="compeletd_btn_icon"
                                        src={compeletd_btn}
                                        alt=""
                                      />
                                      Completed
                                    </button>
                                  </div>
                                  <div className="overview-lesson-mark-complete-btn">
                                    {
                                      <button
                                        disabled={
                                          !lessonStartedDate &&
                                          !lessonCompletedDate
                                        }
                                        onClick={() =>
                                          handleComplete(
                                            totalEstimatedTime,
                                            lesson?.lesson_id,
                                            3
                                          )
                                        }
                                        type="button"
                                      >
                                        Start Assignment
                                      </button>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div >

                            <div className="overview-next-or-preview-btn-folder">
                              {openDialog && (
                                <div className="Course-created-successfully-main">
                                  <div className="Course-created-successfully-container">
                                    <div className="Course-created-successfully-folder">
                                      <h2>
                                        Are you sure you want to start the
                                        assignment?
                                      </h2>
                                      <div className="Course-close-btn">
                                        <button
                                          type="submit"
                                          onClick={cancelRegistration}
                                        >
                                          No
                                        </button>
                                        <button
                                          type="submit"
                                          onClick={() => {
                                            handleComplete(totalEstimatedTime, lesson?.lesson_id, 3);
                                          }}
                                          className="Course-close"
                                        >
                                          Yes
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {
                              courseType === 2 &&
                              (
                                assignments?.length > 0 ? (
                                  <button type="button"
                                    className="overview-lesson-start-assignment"
                                    data-tooltip-id="start-button-tooltip"
                                    onClick={startAssignmentPopupHandler}
                                    style={{ backgroundColor: !isButtonDisable ? 'gray' : '#0068FF' }}
                                    disabled={!isButtonDisable}


                                  >
                                    {!isButtonDisable &&
                                      <Tooltip
                                        id="start-button-tooltip"
                                        place="top"
                                        content="Assignment Already Submitted"
                                        type="light"
                                        effect="float"
                                      />
                                    }
                                    Start Assignment
                                  </button>
                                ) : (
                                  <Ring />
                                )
                              )
                            }
                          </div >
                        </div >
                      </div >
                    )}
                    {
                      activeTab === "Assignment" && (
                        <div className="overview-Assignment-read-body">
                          <div className="start-Assignment-btnnton">
                            {
                              <button
                                onClick={() =>
                                  handleComplete(
                                    totalEstimatedTime,
                                    lesson?.lesson_id,
                                    3
                                  )
                                }
                                type="button"
                              >
                                Start Assignment
                              </button>
                            }
                          </div>
                        </div>
                      )
                    }
                  </div >
                  {isPlaying && <AiVoiceanimation togglePlay={togglePlay} />}
                </div >
              </div >
            </div >
          </div >
        </div >
        {showreuestsuccesfully && (
          <div className="Course-created-successfully-main">
            <div className="Course-created-successfully-container">
              <div className="Course-created-successfully-folder">
                <div className="Course-created-successfully-image">
                  <img src={Course_created_successfully_image} alt="" />
                </div>
                <h2>Lesson Completed</h2>
              </div>
            </div>
          </div>
        )}
      </div >

      {assignmentPopUp &&
        <MultipleAssignmentviewPopup
          type={isPracticeAssignment ? "Practice Assignment" : "Assignment"}
          startAssignmentPopupHandler={startAssignmentPopupHandler}
          startAssignmentHandler={startAssignmentHandler}
          rubric={assignmentRubric}
          assignment={selectedAssignment}
          index={selectedAssignmentIndex}
          courseType={courseType}
        />
      }

      <div style={{ position: 'relative' }}>
        {
          lesson?.teacher?.name ?
            <StudentLessonChatbot
              ai_name={`${lesson?.teacher?.name}`}
              teacher_id={lesson?.teacher?.user_id}
              courseId={course_id}
              lesson_id={lesson_id}
              lesson_name={lesson?.name ?? ""}
              ai_tone={lesson.teacher?.ai_tone}
              ai_avatar={lesson.teacher?.ai_avatar}
              ai_welcome_msg={lesson.teacher?.ai_welcome_msg}
              setIsPlayingTwo={setIsPlayingTwo}
            /> :

            // <Fab
            //   sx={{
            //     position: "fixed",
            //     bottom: 45,
            //     right: 45,
            //     color: "common.white",
            //     "& img": {
            //       borderRadius: "100%",
            //     },
            //   }}
            //   size="small"
            //   aria-label="add"
            // >
            //   <CustomTooltip
            //     title='Loading...'
            //     isVisible='true'
            //     onClose='false'
            //   >
            //     <Ring />
            //   </CustomTooltip>
            // </Fab>

            null
        }
      </div>
    </>
  );
};

export default OverviewLesson;